export const TEMPLATE = 'TEMPLATE';



// WEBPACK FOOTER //
// ./src/store/modules/mail/mutation-types.js